import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

interface ArtifactRow {
  readonly artifactId: string;
  readonly artifactName: string;
  readonly artifactType: string;
  readonly version: string;
  readonly status: string;
}

export function M19ArtifactDashboardPage(): ReactNode {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [rows, setRows] = useState<ArtifactRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ data: ArtifactRow[] }>('/v1/platform/artifacts', { token })
      .then((r) => { if (alive) setRows(r.data); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('m19.artifact.loading')}</p>;
  return (
    <main aria-label="artifact-dashboard">
      <h1>{t('m19.artifact.title')}</h1>
      <table aria-label="artifacts-table">
        <thead><tr><th>{t('m19.artifact.colName')}</th><th>{t('m19.artifact.colType')}</th><th>{t('m19.artifact.colVersion')}</th><th>{t('m19.artifact.colStatus')}</th></tr></thead>
        <tbody>
          {rows.map((a) => (
            <tr key={a.artifactId}>
              <td>{a.artifactName}</td>
              <td>{a.artifactType}</td>
              <td>{a.version}</td>
              <td>{a.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
